import React from "react";
import { CardData } from "@/components/layout/element-layout/grid-layout/GridLayout";
import { DocumentItem } from "@/lib/stores/documentStore";
import GlossaryWidget from   "@/components/cards/widgets/ObjectsWidget";
import CreateDocumentWizard from "@/components/wizards/blueprints/CreateDocumentWizard";
import { Version } from "@/lib/stores/storeTypes";
import { ItemTypeConfig } from "./types";
import { documentsDataSource } from "@/lib/dataSources/sources/documents";

export const documentsConfig: ItemTypeConfig = {
  type: "documents",
  title: "Documents",
  pageSection: "documents",
  eventName: "addDocument",
  emptyStateTitle: "No Documents",
  emptyStateDescription:
    "No documents found for this game. Create your first document to get started.",
  noGameSelectedDescription: "Please select a game to view its documents.",

  /**
   * Transform raw items to CardData using the DataSource transformer
   * This delegates to documentsDataSource.transformers.toCard() for single source of truth
   */
  transformData: (
    documents: DocumentItem[],
    tags: any[],
    getUserNameById: (id: string) => string
  ): CardData[] => {
    if (!documents || !Array.isArray(documents)) {
      console.warn("transformData: documents is not an array:", documents);
      return [];
    }
    
    // Use DataSource transformer with context
    return documentsDataSource.transformers.toCard?.(documents, {
      tags,
      getUserNameById,
    }) || [];
  },

  renderCard: (card: CardData, tags: any[]) => {
    return (
      <GlossaryWidget
        id={card.id}
        gameId={card.gameId}
        title={card.title}
        owner={card.owner}
        tags={card.tags}
        description={card.description}
        lastUpdate={card.lastUpdate}
        version={card.version as number | Version}
        status={card.status}
        folder={card.folder as string}
        itemType="documents"
        icon={card.icon}
        iconBg={card.iconBg}
        shadowType={card.shadowType}
        shadowColor={card.shadowColor}
        hasVersionMismatch={card.hasVersionMismatch}
        onDelete={card.onDelete}
        onEdit={card.onEdit}
      />
    );
  },

  getWizard: (props: any) => <CreateDocumentWizard {...props} />,

  handleDelete: async (id: string, gameId: string, toast: any) => {
    // Handled by hook which has access to the data provider
  },

  handleCardClick: (card: CardData) => {
    // Navigation handled by hook
  },

  handleAdd: () => {
    // Handled by hook
  },
};

